
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiErrorCircle } from 'react-icons/bi';
import PropTypes from 'prop-types';

const ErrorBoundary = ({ error = null, errorInfo = null, className = null }) => {

    const { t } = useTranslation();

    return (
        <div className=" transition duration-150 ease-in-out">
            <div className={`${className}  text-center flex-col  items-center justify-around`}>
  
            <div className=' justify-center flex'>
                    <BiErrorCircle className="text-gray-500 text-4xl" />
                </div>
                <h2 className="font-medium text-lg mt-4 text-gray-500">
              
                    {t('errors.oops_title')} !</h2>
                <p className="whitespace-pre-wrap text-sm my-1">
                    {t('errors.oops_subtitle')}
                </p>
            </div>

        </div>
    );
}

ErrorBoundary.propTypes = {
  error: PropTypes.any,
  errorInfo: PropTypes.object,
  className: PropTypes.string,
};

export default ErrorBoundary;

